import React from 'react';

import {SingleInput} from 'comp/input';
import {LoaderButton} from 'comp/button';
import GoogleLoginButton from './GoogleLoginButton';
import styles from './UsernamePassword.scss';

const UsernamePassword = ({
  isLoading,
  setEmail,
  setPassword,
  setRememberMe,
  setRememberMeValue,
  submitLogin,
  submitLoginWithGoogle,
  toggleRememberMe,
  googleSSOEnabled,
}) => {
  const getGoogleSSO = () => {
    if (googleSSOEnabled) {
      return (
        <GoogleLoginButton
          type='warn'
          size='large'
          onSuccess={submitLoginWithGoogle}
          className={styles.noMargin}
        />
      );
    }

    return null;
  };
  return (
    <div
      className={styles.content}
    >
      <SingleInput
        ref={setEmail}
        id='user-email'
        name='user-email'
        title='Email'
        inputType='email'
        autoFocus
        onReturnKey={submitLogin}
      />
      <SingleInput
        ref={setPassword}
        id='user-password'
        name='user-password'
        title='Password'
        inputType='password'
        onReturnKey={submitLogin}
      />
      <div className={styles.controls}>
        <input
          ref={setRememberMe}
          onClick={setRememberMeValue}
          type='checkbox'
          id='remember_me'
          name='remember_me'
        />
        <label onClick={toggleRememberMe} className={styles.label}>Remember Me</label>
        <a
          href='https://app.unbounce.com/forgot'
          className={styles.forget}
          htmlFor='remember_me'
          target='_blank'
          rel="noopener noreferrer"
        >
          Forgot Password?
        </a>
      </div>
      <LoaderButton
        text='Log In to Unbounce'
        isLoading={isLoading}
        loadingText='Logging In...'
        type='action'
        clickAction={submitLogin}
        size='large'
        className={styles.submit}
      />
      {getGoogleSSO()}
    </div>
  );
};

UsernamePassword.propTypes = {
  isLoading: React.PropTypes.bool,
  setEmail: React.PropTypes.func,
  setPassword: React.PropTypes.func,
  setRememberMe: React.PropTypes.func,
  setRememberMeValue: React.PropTypes.func,
  submitLogin: React.PropTypes.func,
  submitLoginWithGoogle: React.PropTypes.func,
  toggleRememberMe: React.PropTypes.func,
  googleSSOEnabled: React.PropTypes.bool,
};

export default UsernamePassword;



// WEBPACK FOOTER //
// ./src/components/login/components/UsernamePassword.jsx